import { render } from "./EditUserGuideDialog.vue?vue&type=template&id=60d6a6aa"
import script from "./EditUserGuideDialog.vue?vue&type=script&lang=js"
export * from "./EditUserGuideDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__